<template>
  <component
    :is="tag"
    class="flex items-center py-1 px-2 space-x-1 text-sm text-white bg-lk-green rounded-full"
  >
    <span class="hover:underline">
      {{ displayName }}
    </span>
    <XCircleIcon
      class="w-4 h-4 text-lk-green cursor-pointer fill-white"
      @click="emit('remove', contentId)"
    />
  </component>
</template>
<script setup lang="ts">
import { XCircleIcon } from '@heroicons/vue/24/outline';

withDefaults(defineProps<{
  contentId: string | number
  displayName: string | number
  tag?: string
}>(), {
  tag: 'div',
});

const emit = defineEmits<{(e: 'remove', id: string | number): void}>();
</script>

